// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.attribute_change_field */
var AttributeChangeField;
(function (AttributeChangeField) {
    AttributeChangeField["number_value"] = "number_value";
    AttributeChangeField["text_value"] = "text_value";
    AttributeChangeField["check_value"] = "check_value";
    AttributeChangeField["timestamp_value"] = "timestamp_value";
    AttributeChangeField["measurement_unit"] = "measurement_unit";
    AttributeChangeField["inventory_item"] = "inventory_item";
    AttributeChangeField["media"] = "media";
    AttributeChangeField["note"] = "note";
    AttributeChangeField["computed_number"] = "computed_number";
    AttributeChangeField["computed_number_unit"] = "computed_number_unit";
    AttributeChangeField["cell_value"] = "cell_value";
    AttributeChangeField["cell_index"] = "cell_index";
    AttributeChangeField["cell_computed"] = "cell_computed";
    AttributeChangeField["qualifier"] = "qualifier";
    AttributeChangeField["limit_value"] = "limit_value";
    AttributeChangeField["uncertainty"] = "uncertainty";
    AttributeChangeField["raw_text"] = "raw_text";
    AttributeChangeField["flags"] = "flags";
    AttributeChangeField["remark"] = "remark";
})(AttributeChangeField || (AttributeChangeField = {}));
;
export default AttributeChangeField;
/** Zod schema for attribute_change_field */
export const attributeChangeField = z.nativeEnum(AttributeChangeField);
//# sourceMappingURL=AttributeChangeField.js.map